<template>
  <div>
    <!--Stats cards-->
    <dashboard-filter
      @output="inputListeners"
      @filter="fetch"
    />
    <count-cards :input="inputDate"/>
    <show-map
      v-if="projectOnline"
      name="example"
      :allTags="tags"
      @openModalDashboard="openModal"
    ></show-map>
    <div v-show="true"></div>
  </div>
</template>
<script>
  import ShowMap from 'src/components/showMap.vue'
  import CountCards from 'src/pages/Dashboard/CountCards'
  import DashboardFilter from 'src/pages/Dashboard/DashboardFilter'
  import {mapActions, mapGetters} from 'vuex'
  import {apiEduService, defineApiEduPost} from 'src/services/ApiEducacional.js'

  import {verifyEmptyTags, defineWhereObject} from 'src/services/DashboardCounter'
  import GalleryComponent from '../../components/GalleryComponent'

  export default {
    components: {
      CountCards,
      ShowMap,
      DashboardFilter,
      GalleryComponent
    },

    data () {
      return {
        inputDate: null
      }
    },

    computed: {
      ...mapGetters('gallery', ['showGallery', 'imagesGallery', 'galleryIndex']),
      ...mapGetters('eventsSpecifications', ['eventsSpecifications']),
      projectOnline: () => {
        return process.env.PROJECT_ONLINE
      },
      ...mapGetters('tags', {
        tagsSelected: 'selecteds',
        tags: 'tags'
      }),
      ...mapGetters('categories', {
        categoriesApi: 'categoriesApi'
      }),
      ...mapGetters(['rangeDate', 'user'])
    },

    methods: {
      openModal (event) {
        console.log('abre modal caralho', event)
        this.indexGallery = event.index
        this.infoContent = event.infoContent
        this.showModal = true
      },
      ...mapActions(['changeRange', 'setDatasApiEdu']),
      ...mapActions('categories', {fetchCategories: 'fetchAll'}),
      ...mapActions('customers', {
        fetchParticipantCount: 'fetchParticipantCount'
      }),
      ...mapActions('events', {
        setAllFiltered: 'setAllFiltered',
        fetchEvents: 'fetchAll',
        fetchEventsIds: 'fetchIds'
      }),
      ...mapActions('surveys', ['dashboardSurveysByFilter']),
      ...mapActions('lamps', ['dashboardLampsByFilter']),
      ...mapActions('users', ['dashboardUsersByFilter']),
      ...mapActions('tickets', ['dashboardTicketsByFilter', 'dashboardWinnerTicketsByFilter']),
      ...mapActions('tags', {
        setTags: 'setTagsDashboard'
      }),
      ...mapActions('events', ['filterEventsByTags', 'filterEventsByDate']),
      ...mapActions('eventsSpecifications', {fetchSpecifications: 'fetchAll'}),
      inputListeners (val) {
        this.inputDate = val
        this.fetch()
      },
      fetch () {
        const formatedDate = []
        if (this.rangeDate && this.rangeDate.length > 0) {
          formatedDate.push(
            new Date(this.rangeDate[0]).toISOString().replace('03:00:00', '00:00:00')
          )
          formatedDate.push(
            new Date(this.rangeDate[1]).toISOString().replace('03:00:00', '23:59:59')
          )
        }

        if (verifyEmptyTags(this.tagsSelected)) {
          return this.fetchSpecifications({limit: 99999})
            .then(() => this.getEventsBySpecificationsEventsIds(formatedDate)
              .then(events => [
                this.fetchCounters(events)
              ])
            )
        }

        this.changeRange(formatedDate)
        this.setTags({
          payload: this.tagsSelected,
          tags: this.tags
        })

        this.getEventsSpecifications()
          .then(() => {
            this.getEventsBySpecificationsEventsIds(formatedDate)
              .then(events => [
                this.fetchCounters(events)
              ])
          })
          .catch(err => {
            console.log('erro na busca do filtro', err)
          })

        this.fetchCounterByDate(formatedDate)
          .catch(err => console.log(err))
        //
        // this.filterEventsByDate(
        //   {
        //     dateRange: formatedDate,
        //     tags: this.tagsSelected
        //   }
        // )
        //   .then((events) => this.fetchCounters(events))
        //   .catch(err => console.log(err))
      },

      getEventsSpecifications () {
        const whereTags = defineWhereObject(undefined, this.tagsSelected, 'tagsIds')
        return this.fetchSpecifications({
          where: {
            '$and': whereTags['$and']
          },
          limit: 99999
        })
      },

      getEventsBySpecificationsEventsIds (formatedDate) {
        let whereQuery = []
        if (!verifyEmptyTags(this.tagsSelected)) {
          whereQuery.push({
            '$or': this.eventsSpecifications.map(item => Object.assign({
              _id: item.eventId
            }))
          })
        }
        if (formatedDate && formatedDate.length === 2) {
          whereQuery.push({
            'startDate': {
              '$gte': formatedDate[0]
            }
          })
          whereQuery.push(
            {
              'endDate': {
                '$lte': formatedDate[1]
              }
            })
        }

        return whereQuery.length > 0 ? this.fetchEvents({
          where: {
            '$and': whereQuery
          },
          limit: 99999999
        }) : this.fetchEvents({
          limit: 99999999
        })
      },

      fetchCounterByDate (formatedDate) {
        let promises = [this.dashboardUsersByFilter({dateRange: formatedDate})]
        if (process.env.PROJECT_ONLINE) {
          promises.push(this.getEventsEDUCount(formatedDate, this.tagsSelected))
          promises.push(this.getSpeechesEDUCount(formatedDate, this.tagsSelected))
        }

        return Promise.all(promises).catch(err => {
          console.log(err)
          return err
        })
      },

      getTagsThroughCategories () {
        const tags = {}
        for (let categorieId in this.tagsSelected) {
          if (this.categoriesApi.find(item => item._id === categorieId)) {
            tags[categorieId] = this.tagsSelected[categorieId]
          }
        }
        return tags
      },

      getSpeechesEDUCount (dateRange) {
        this.setDatasApiEdu({loading: true})
        return apiEduService.getCountSpeeches({
          dateRange: this.formatDate(dateRange),
          tags: defineApiEduPost(this.getTagsThroughCategories(), this.tags)
        }).then(res => {
          this.setDatasApiEdu({
            speeches: res,
            loading: false
          })
        }).catch(err => console.log(err))
      },
      getEventsEDUCount (dateRange) {
        this.setDatasApiEdu({loading: true})
        return apiEduService.getCountEvents({
          dateRange: this.formatDate(dateRange),
          tags: defineApiEduPost(this.getTagsThroughCategories(), this.tags)
        }).then(res => {
          this.setDatasApiEdu({
            events: res,
            loading: false
          })
        }).catch(err => console.log(err))
      },
      fetchCounters (events) {
        const eventsId = events.map(event => event._id)
        return Promise.all([
          this.dashboardLampsByFilter({eventsId}),
          this.dashboardTicketsByFilter({eventsId}),
          this.dashboardWinnerTicketsByFilter({eventsId}),
          this.dashboardSurveysByFilter({eventsId}),
          this.fetchParticipantCount({eventsId})
        ]).catch(err => {
          console.log(err)
          return err
        })
      },

      formatDate (arr) {
        if (arr.length !== 0) {
          return arr.map(item => {
            return item.substr(0, 10)
          })
        }
      }
    },

    mounted () {
      if (!this.user) {
        this.$router.push({name: 'login'})
      }
      this.fetch()
      this.fetchCategories({limit: 9999})
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard/Dashboard.vue